function formatPrice(priceElement) {
	if (!priceElement) return;
	const priceText = priceElement.textContent;
	const priceCleaned = priceText
		.replace('R$', '')
		.replace(' /mês', '')
		.replace(',', '.');
	return parseFloat(priceCleaned).toFixed(2);
}

function pushDataLayer(event, data) {
	dataLayer?.push({
		event: event,
		...data
	});
}

function observeIntersection(targetElement, event, eventData) {
	if (!targetElement) return;
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				pushDataLayer(event, eventData);
			}
		});
	}, options);
	observer.observe(targetElement);
}

function addClickListener(element, event, eventData) {
	element?.addEventListener('click', function () {
		// Dentro do escopo desta função de callback, 'this' refere-se ao elemento clicado
		pushDataLayer(event, eventData);
	});
}

const options = {
	root: null,
	rootMargin: '0px',
	threshold: 0.5
};

window.addEventListener('DOMContentLoaded', () => {
	pushDataLayer('page_view', {
		page_location: document.location.href,
		page_referrer: document.location.host,
		page_title: document.title,
		page_type: document.location.pathname,
		page_path: document.location.pathname
	});
});

const bannerGloboplay = {
	page_location: document.location.href,
	page_path: document.location.pathname,
	link_domain: document.location.host,
	link_classes: 'btn_entretenimento_assinar_globoplay',
	link_id: 'btn_entretenimento_assinar_globoplay',
	link_url: document.location.href,
	outbound: false
};
const bannerGloboplayCarousel = {
	page_location: document.location.href,
	page_path: document.location.pathname,
	link_domain: document.location.host,
	link_classes: 'btn_eu_quero_entretenimento_globoplay',
	link_id: 'btn_eu_quero_entretenimento_globoplay',
	link_url: document.location.href,
	outbound: false
};
const bannerMax = {
	page_location: document.location.href,
	page_path: document.location.pathname,
	link_domain: document.location.host,
	link_classes: 'entretenimento_max',
	link_id: 'btn_eu_quero_entretenimento_max',
	link_url: document.location.href,
	outbound: false
};
const bannerParamount = {
	page_location: document.location.href,
	page_path: document.location.pathname,
	link_domain: document.location.host,
	link_classes: 'btn_eu_quero_entretenimento_paramount',
	link_id: 'btn_eu_quero_entretenimento_paramount',
	link_url: document.location.href,
	outbound: false
};

const btnAssineJa = document.getElementById('btn_banner_assine_ja');
const btnSaibaMaisBanner = document.getElementById('btn_saiba_mais');
const btnGloboplayEuQuero = document.getElementById(
	'btn_section_globoplay_eu_quero'
);
const btnMaxEuQuero = document.getElementById('btn_max_eu_quero');
const btnParamountEuQuero = document.getElementById('btn_paramount_eu_quero');

addClickListener(btnAssineJa, 'banner_click', bannerGloboplay);
addClickListener(btnSaibaMaisBanner, 'banner_click', bannerGloboplay);
addClickListener(btnGloboplayEuQuero, 'banner_click', bannerGloboplayCarousel);
addClickListener(btnMaxEuQuero, 'banner_click', bannerMax);
addClickListener(btnParamountEuQuero, 'banner_click', bannerParamount);

const sectionPremComb = document.getElementById('section_premiere_combate');
const premierePrice = document.getElementById('premiere_price');
const combatePrice = document.getElementById('combate_price');
const combPremPrice = document.getElementById('premiere_combate_price');
const bannerEsportPremiereData = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-premiere',
	item_brand: 'oi-entretenimento-premiere',
	item_category: 'oi-entretenimento-premiere',
	price: formatPrice(premierePrice),
	quantity: 1
}
const bannerEsportCombateData = 	{
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-combate',
	item_brand: 'oi-entretenimento-combate',
	item_category: 'oi-entretenimento-combate',
	price: formatPrice(combatePrice),
	quantity: 1
}
const bannerEsportPremiereCombateData = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-premiere-combate',
	item_brand: 'oi-entretenimento-premiere-combate',
	item_category: 'oi-entretenimento-premiere-combate',
	price: formatPrice(combPremPrice),
	quantity: 1
}
const sectionPremCombData = {
	item_list_name: 'oi-entretenimento-stream',
	item_list_id: 'oi-entretenimento-stream',

	items: [
		bannerEsportPremiereData, bannerEsportCombateData, bannerEsportCombateData
	]
};


observeIntersection(sectionPremComb, 'view_item_list', sectionPremCombData);

function createButtonData(data) {
	return {
		item_list_name: 'oi-entretenimento-stream',
	item_list_id: 'oi-entretenimento-stream',
		items: [
			data
		]
	};
}
const price_premiere_element = document.getElementById('premiere_price');
const price_combate_element = document.getElementById('combate_price');
const price_premiere_combate_element = document.getElementById(
	'premiere_combate_price'
);

const btnPremiereData = createButtonData( bannerEsportPremiereData);
const btnCombateData = createButtonData( bannerEsportCombateData);
const btnPremiereCombateData = createButtonData(bannerEsportPremiereCombateData);

function addClickListenerPremComb(button, eventData) {
	button?.addEventListener('click', function () {
		pushDataLayer('select_item', eventData);
	});
}

const btnPremiere = document.getElementById('btn_premiere_eu_quero');
const btnCombate = document.getElementById('btn_combate_eu_quero');
const btnPremiereCombate = document.getElementById(
	'btn_premiere_combate_eu_quero'
);

addClickListenerPremComb(btnPremiere, btnPremiereData);
addClickListenerPremComb(btnCombate, btnCombateData);
addClickListenerPremComb(btnPremiereCombate, btnPremiereCombateData);

const globoplayPrice = document.getElementById('itemGloboplayPrice');
const paramountPrice = document.getElementById('paramount_price');
const premiereCombatePrice = document.getElementById(
	'premiere_combate_price'
);
const cardAssineJaGloboplay = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-globoplay',
	item_brand: 'oi-entretenimento-globoplay',
	item_category: 'oi-entretenimento-globoplay',
	price: formatPrice(globoplayPrice),
	quantity: 1
}

const cardAssineJaParamount = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-paramount',
	item_brand: 'oi-entretenimento-paramount',
	item_category: 'oi-entretenimento-paramount',
	price: formatPrice(paramountPrice),
	quantity: 1
}
const cardAssineJaPremiere = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-premiere',
	item_brand: 'oi-entretenimento-premiere',
	item_category: 'oi-entretenimento-premiere',
	price: formatPrice(premierePrice),
	quantity: 1
}
const cardAssineJaCombate = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-combate',
	item_brand: 'oi-entretenimento-combate',
	item_category: 'oi-entretenimento-combate',
	price: formatPrice(combatePrice),
	quantity: 1
}
const cardAssineJaCombatePremiere = {
	item_id: 'oi-entretenimento-stream',
	item_name: 'oi-entretenimento-combo-combate-premiere',
	item_brand: 'oi-entretenimento-combo-combate-premiere',
	item_category: 'oi-entretenimento-combo-combate-premiere',
	price: formatPrice(combatePrice),
	quantity: 1
}
const sectionAssineJa = document.getElementById('section_entretenimento');
const sectionEntretenimentoData = {
	item_list_name: 'oi-entretenimento-stream',
	item_list_id: 'oi-entretenimento-stream',

	items: [
		cardAssineJaGloboplay,
		cardAssineJaParamount,
		cardAssineJaPremiere,
		cardAssineJaCombate,
		cardAssineJaCombatePremiere,
	]
};


observeIntersection(
	sectionAssineJa,
	'view_item_list',
	sectionEntretenimentoData
);

window.addEventListener('DOMContentLoaded', () => {
	const btnConsultarDisponibilidade = document.getElementById(
		'btn_consultar_disponibilidade'
	);

	btnConsultarDisponibilidade?.addEventListener('click', function () {
		let selectedPlan = [];

		card?.forEach((item) => {
			if (item?.plan == 'Globoplay') {
				selectedPlan.push(cardAssineJaGloboplay);
			}
			if (item?.plan == 'Paramount+') {
				selectedPlan.push(cardAssineJaParamount);
			}
			if (item?.plan == 'Premiere') {
				
				selectedPlan.push(cardAssineJaPremiere);
			}
			if (item?.plan == 'Combate') {
				selectedPlan.push(cardAssineJaCombate);
			}
			if (item?.plan == 'Premiere + Combate') {
				selectedPlan.push(cardAssineJaCombatePremiere);
			}
		});

		dataLayer?.push({
			event: 'select_item',
			item_list_id: 'oi-entretenimento-stream',
			item_list_name: 'aoi-entretenimento-stream',
			items: selectedPlan
		});
	});
});

const assineJaBtnTodos = document.getElementById('assineJaBtnTodos')
const assineJaBtnEntretenimento = document.getElementById('assineJaBtnEntretenimento')
const assineJaBtnEsportes = document.getElementById('assineJaBtnEsportes')

assineJaBtnTodos?.addEventListener('click',() => {
	pushDataLayer('select_item', {event: 'select_item',
	item_list_id: 'guia_assine_ja-stream',
	item_list_name: 'guia_assine_ja-stream',
	items: sectionEntretenimentoData?.items})
})

assineJaBtnEntretenimento?.addEventListener('click',() => {
	pushDataLayer('select_item', {event: 'select_item',
	item_list_id: 'guia_assine_ja-stream',
	item_list_name: 'guia_assine_ja-stream',
	items:[sectionEntretenimentoData?.items[0], sectionEntretenimentoData?.items[1]]})
})
assineJaBtnEsportes?.addEventListener('click',() => {
	pushDataLayer('select_item', {event: 'select_item',
	item_list_id: 'guia_assine_ja-stream',
	item_list_name: 'guia_assine_ja-stream',
	items:[sectionEntretenimentoData?.items[2], sectionEntretenimentoData?.items[3], sectionEntretenimentoData?.items[4]]})
})